const items = [
    {
        fruit: ["graper", "Uva"],
    },
    {
        fruit: ["strawberry", "Morango"],
    },
    {
        fruit: ["banana", "Banana"],
    },
    {
        fruit: ["kiwi", "Kiwi"],
    },
];

export default items;
